"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/admin_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkSeatAssignmentRow = exports.AdminEventServiceBulkAssignSeatsResponse = exports.AdminEventServiceBulkAssignSeatsRequest = exports.AdminEventServiceImportSeatSegmentGroupResponse = exports.AdminEventServiceImportSeatSegmentGroupRequest = exports.AdminSeatSegmentInput = exports.AdminSeatInput = exports.AdminEventServiceGetEventRolesResponse = exports.AdminEventServiceGetEventRolesRequest = exports.AdminEventServiceRemoveEventRoleResponse = exports.AdminEventServiceRemoveEventRoleRequest = exports.AdminEventServiceAddEventRoleResponse = exports.AdminEventServiceAddEventRoleRequest = exports.AdminEventServiceCreateVoucherCodeResponse = exports.AdminEventServiceCreateVoucherCodeRequest = exports.AdminEventServiceExtractWinnerResponse_Applicant = exports.AdminEventServiceExtractWinnerResponse = exports.AdminEventServiceExtractWinnerRequest_TargetUser = exports.AdminEventServiceExtractWinnerRequest_WinnerTicket = exports.AdminEventServiceExtractWinnerRequest = exports.AdminEventServiceStartLotteryLoserProcessResponse = exports.AdminEventServiceStartLotteryLoserProcessRequest = exports.AdminEventServiceStartLotteryWinnerProcessResponse = exports.AdminEventServiceStartLotteryWinnerProcessRequest = exports.AdminEventServiceDetachTicketBonusMediaResponse = exports.AdminEventServiceDetachTicketBonusMediaRequest = exports.AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData = exports.AdminEventServiceGetTicketBonusMediaResponse = exports.AdminEventServiceGetTicketBonusMediaRequest = exports.AdminEventServiceAttachTicketBonusMediaResponse = exports.AdminEventServiceAttachTicketBonusMediaRequest = exports.AdminEventServiceUnregisterEventBonusMediaResponse = exports.AdminEventServiceUnregisterEventBonusMediaRequest = exports.AdminEventServiceGetEventBonusMediaResponse_BonusInfo = exports.AdminEventServiceGetEventBonusMediaResponse = exports.AdminEventServiceGetEventBonusMediaRequest = exports.AdminEventServiceRegisterEventBonusMediaResponse = exports.AdminEventServiceRegisterEventBonusMediaRequest = exports.AdminEventServiceCompleteBonusMediaFilePartUploadResponse = exports.AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo = exports.AdminEventServiceCompleteBonusMediaFilePartUploadRequest = exports.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl = exports.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse = exports.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest = exports.AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse = exports.AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
const admin_common_pb_1 = require("./admin_common_pb");
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest
 */
class AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ファイル名
         *
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest, a, b);
    }
}
exports.AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest = AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest;
AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest.runtime = protobuf_1.proto3;
AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest.typeName = "spwn.event.v1.AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest";
AdminEventServiceGetSignedUrlForBonusMediaFileUploadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse
 */
class AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アップロードされたファイルのID
         *
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        /**
         * アップロード時に指定するヘッダー
         *
         * @generated from field: map<string, string> headers_for_upload = 2;
         */
        this.headersForUpload = {};
        /**
         * アップロード用のURL
         *
         * @generated from field: string url_for_upload = 3;
         */
        this.urlForUpload = "";
        /**
         * ダウンロード用のURL
         *
         * @generated from field: string url_for_download = 4;
         */
        this.urlForDownload = "";
        /**
         * S3 bucket内でのobjectに対するpath
         *
         * @generated from field: string s3_object_path = 5;
         */
        this.s3ObjectPath = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse, a, b);
    }
}
exports.AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse = AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse;
AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse.runtime = protobuf_1.proto3;
AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse.typeName = "spwn.event.v1.AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse";
AdminEventServiceGetSignedUrlForBonusMediaFileUploadResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "headers_for_upload", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 3, name: "url_for_upload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "url_for_download", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "s3_object_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest
 */
class AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ファイル名
         *
         * @generated from field: string filename = 1;
         */
        this.filename = "";
        /**
         * 分割数
         *
         * @generated from field: int32 num_of_parts = 2;
         */
        this.numOfParts = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest, a, b);
    }
}
exports.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest = AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest;
AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest.runtime = protobuf_1.proto3;
AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest.typeName = "spwn.event.v1.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest";
AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "num_of_parts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse
 */
class AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * アップロードされたファイルのID
         *
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        /**
         * マルチパートアップロード毎の固有のID
         *
         * @generated from field: string upload_id = 2;
         */
        this.uploadId = "";
        /**
         * アップロード用のURLs
         *
         * @generated from field: repeated spwn.event.v1.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse.PartUrl urls_for_upload = 3;
         */
        this.urlsForUpload = [];
        /**
         * ダウンロード用のURL
         *
         * @generated from field: string url_for_download = 4;
         */
        this.urlForDownload = "";
        /**
         * S3 bucket内でのobjectに対するpath
         *
         * @generated from field: string s3_object_path = 5;
         */
        this.s3ObjectPath = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse, a, b);
    }
}
exports.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse = AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse;
AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse.runtime = protobuf_1.proto3;
AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse.typeName = "spwn.event.v1.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse";
AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "upload_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "urls_for_upload", kind: "message", T: AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl, repeated: true },
    { no: 4, name: "url_for_download", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "s3_object_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse.PartUrl
 */
class AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 part_number = 1;
         */
        this.partNumber = 0;
        /**
         * @generated from field: string url = 2;
         */
        this.url = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl, a, b);
    }
}
exports.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl = AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl;
AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl.runtime = protobuf_1.proto3;
AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl.typeName = "spwn.event.v1.AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse.PartUrl";
AdminEventServiceGetSignedUrlsForBonusMediaFilePartUploadResponse_PartUrl.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "part_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceCompleteBonusMediaFilePartUploadRequest
 */
class AdminEventServiceCompleteBonusMediaFilePartUploadRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * マルチパートアップロード毎の固有のID
         *
         * @generated from field: string upload_id = 1;
         */
        this.uploadId = "";
        /**
         * S3 bucket内でのobjectに対するpath
         *
         * @generated from field: string s3_object_path = 2;
         */
        this.s3ObjectPath = "";
        /**
         * マルチパートアップロード済みの各パートの情報
         *
         * @generated from field: repeated spwn.event.v1.AdminEventServiceCompleteBonusMediaFilePartUploadRequest.PartInfo parts = 3;
         */
        this.parts = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceCompleteBonusMediaFilePartUploadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceCompleteBonusMediaFilePartUploadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceCompleteBonusMediaFilePartUploadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceCompleteBonusMediaFilePartUploadRequest, a, b);
    }
}
exports.AdminEventServiceCompleteBonusMediaFilePartUploadRequest = AdminEventServiceCompleteBonusMediaFilePartUploadRequest;
AdminEventServiceCompleteBonusMediaFilePartUploadRequest.runtime = protobuf_1.proto3;
AdminEventServiceCompleteBonusMediaFilePartUploadRequest.typeName = "spwn.event.v1.AdminEventServiceCompleteBonusMediaFilePartUploadRequest";
AdminEventServiceCompleteBonusMediaFilePartUploadRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "upload_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "s3_object_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parts", kind: "message", T: AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceCompleteBonusMediaFilePartUploadRequest.PartInfo
 */
class AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 part_number = 1;
         */
        this.partNumber = 0;
        /**
         * @generated from field: string etag = 2;
         */
        this.etag = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo, a, b);
    }
}
exports.AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo = AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo;
AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo.runtime = protobuf_1.proto3;
AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo.typeName = "spwn.event.v1.AdminEventServiceCompleteBonusMediaFilePartUploadRequest.PartInfo";
AdminEventServiceCompleteBonusMediaFilePartUploadRequest_PartInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "part_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "etag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceCompleteBonusMediaFilePartUploadResponse
 */
class AdminEventServiceCompleteBonusMediaFilePartUploadResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 最終的にアップロードされたファイルのETag
         *
         * @generated from field: string etag = 1;
         */
        this.etag = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceCompleteBonusMediaFilePartUploadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceCompleteBonusMediaFilePartUploadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceCompleteBonusMediaFilePartUploadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceCompleteBonusMediaFilePartUploadResponse, a, b);
    }
}
exports.AdminEventServiceCompleteBonusMediaFilePartUploadResponse = AdminEventServiceCompleteBonusMediaFilePartUploadResponse;
AdminEventServiceCompleteBonusMediaFilePartUploadResponse.runtime = protobuf_1.proto3;
AdminEventServiceCompleteBonusMediaFilePartUploadResponse.typeName = "spwn.event.v1.AdminEventServiceCompleteBonusMediaFilePartUploadResponse";
AdminEventServiceCompleteBonusMediaFilePartUploadResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "etag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceRegisterEventBonusMediaRequest
 */
class AdminEventServiceRegisterEventBonusMediaRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * S3 bucket内でのobjectに対するpath
         *
         * @generated from field: string s3_object_path = 3;
         */
        this.s3ObjectPath = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceRegisterEventBonusMediaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceRegisterEventBonusMediaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceRegisterEventBonusMediaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceRegisterEventBonusMediaRequest, a, b);
    }
}
exports.AdminEventServiceRegisterEventBonusMediaRequest = AdminEventServiceRegisterEventBonusMediaRequest;
AdminEventServiceRegisterEventBonusMediaRequest.runtime = protobuf_1.proto3;
AdminEventServiceRegisterEventBonusMediaRequest.typeName = "spwn.event.v1.AdminEventServiceRegisterEventBonusMediaRequest";
AdminEventServiceRegisterEventBonusMediaRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bonus_info", kind: "message", T: admin_common_pb_1.EventBonusMedia },
    { no: 3, name: "s3_object_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceRegisterEventBonusMediaResponse
 */
class AdminEventServiceRegisterEventBonusMediaResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceRegisterEventBonusMediaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceRegisterEventBonusMediaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceRegisterEventBonusMediaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceRegisterEventBonusMediaResponse, a, b);
    }
}
exports.AdminEventServiceRegisterEventBonusMediaResponse = AdminEventServiceRegisterEventBonusMediaResponse;
AdminEventServiceRegisterEventBonusMediaResponse.runtime = protobuf_1.proto3;
AdminEventServiceRegisterEventBonusMediaResponse.typeName = "spwn.event.v1.AdminEventServiceRegisterEventBonusMediaResponse";
AdminEventServiceRegisterEventBonusMediaResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetEventBonusMediaRequest
 */
class AdminEventServiceGetEventBonusMediaRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetEventBonusMediaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetEventBonusMediaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetEventBonusMediaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetEventBonusMediaRequest, a, b);
    }
}
exports.AdminEventServiceGetEventBonusMediaRequest = AdminEventServiceGetEventBonusMediaRequest;
AdminEventServiceGetEventBonusMediaRequest.runtime = protobuf_1.proto3;
AdminEventServiceGetEventBonusMediaRequest.typeName = "spwn.event.v1.AdminEventServiceGetEventBonusMediaRequest";
AdminEventServiceGetEventBonusMediaRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetEventBonusMediaResponse
 */
class AdminEventServiceGetEventBonusMediaResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.AdminEventServiceGetEventBonusMediaResponse.BonusInfo bonus_info = 1;
         */
        this.bonusInfo = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetEventBonusMediaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetEventBonusMediaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetEventBonusMediaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetEventBonusMediaResponse, a, b);
    }
}
exports.AdminEventServiceGetEventBonusMediaResponse = AdminEventServiceGetEventBonusMediaResponse;
AdminEventServiceGetEventBonusMediaResponse.runtime = protobuf_1.proto3;
AdminEventServiceGetEventBonusMediaResponse.typeName = "spwn.event.v1.AdminEventServiceGetEventBonusMediaResponse";
AdminEventServiceGetEventBonusMediaResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bonus_info", kind: "message", T: AdminEventServiceGetEventBonusMediaResponse_BonusInfo, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetEventBonusMediaResponse.BonusInfo
 */
class AdminEventServiceGetEventBonusMediaResponse_BonusInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool exists_binding = 2;
         */
        this.existsBinding = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetEventBonusMediaResponse_BonusInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetEventBonusMediaResponse_BonusInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetEventBonusMediaResponse_BonusInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetEventBonusMediaResponse_BonusInfo, a, b);
    }
}
exports.AdminEventServiceGetEventBonusMediaResponse_BonusInfo = AdminEventServiceGetEventBonusMediaResponse_BonusInfo;
AdminEventServiceGetEventBonusMediaResponse_BonusInfo.runtime = protobuf_1.proto3;
AdminEventServiceGetEventBonusMediaResponse_BonusInfo.typeName = "spwn.event.v1.AdminEventServiceGetEventBonusMediaResponse.BonusInfo";
AdminEventServiceGetEventBonusMediaResponse_BonusInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media", kind: "message", T: admin_common_pb_1.EventBonusMedia },
    { no: 2, name: "exists_binding", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceUnregisterEventBonusMediaRequest
 */
class AdminEventServiceUnregisterEventBonusMediaRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: string media_id = 2;
         */
        this.mediaId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceUnregisterEventBonusMediaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceUnregisterEventBonusMediaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceUnregisterEventBonusMediaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceUnregisterEventBonusMediaRequest, a, b);
    }
}
exports.AdminEventServiceUnregisterEventBonusMediaRequest = AdminEventServiceUnregisterEventBonusMediaRequest;
AdminEventServiceUnregisterEventBonusMediaRequest.runtime = protobuf_1.proto3;
AdminEventServiceUnregisterEventBonusMediaRequest.typeName = "spwn.event.v1.AdminEventServiceUnregisterEventBonusMediaRequest";
AdminEventServiceUnregisterEventBonusMediaRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceUnregisterEventBonusMediaResponse
 */
class AdminEventServiceUnregisterEventBonusMediaResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceUnregisterEventBonusMediaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceUnregisterEventBonusMediaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceUnregisterEventBonusMediaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceUnregisterEventBonusMediaResponse, a, b);
    }
}
exports.AdminEventServiceUnregisterEventBonusMediaResponse = AdminEventServiceUnregisterEventBonusMediaResponse;
AdminEventServiceUnregisterEventBonusMediaResponse.runtime = protobuf_1.proto3;
AdminEventServiceUnregisterEventBonusMediaResponse.typeName = "spwn.event.v1.AdminEventServiceUnregisterEventBonusMediaResponse";
AdminEventServiceUnregisterEventBonusMediaResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceAttachTicketBonusMediaRequest
 */
class AdminEventServiceAttachTicketBonusMediaRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 特典ファイルを紐付けたいイベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * 特典ファイルを紐付けたいイベント中のチケットID一覧
         *
         * @generated from field: repeated string ticket_ids = 2;
         */
        this.ticketIds = [];
        /**
         * 特典ファイルのID
         *
         * @generated from field: string media_id = 3;
         */
        this.mediaId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceAttachTicketBonusMediaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceAttachTicketBonusMediaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceAttachTicketBonusMediaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceAttachTicketBonusMediaRequest, a, b);
    }
}
exports.AdminEventServiceAttachTicketBonusMediaRequest = AdminEventServiceAttachTicketBonusMediaRequest;
AdminEventServiceAttachTicketBonusMediaRequest.runtime = protobuf_1.proto3;
AdminEventServiceAttachTicketBonusMediaRequest.typeName = "spwn.event.v1.AdminEventServiceAttachTicketBonusMediaRequest";
AdminEventServiceAttachTicketBonusMediaRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "release_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "expired_at", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceAttachTicketBonusMediaResponse
 */
class AdminEventServiceAttachTicketBonusMediaResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 紐付けが完了したファイルのID
         *
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceAttachTicketBonusMediaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceAttachTicketBonusMediaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceAttachTicketBonusMediaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceAttachTicketBonusMediaResponse, a, b);
    }
}
exports.AdminEventServiceAttachTicketBonusMediaResponse = AdminEventServiceAttachTicketBonusMediaResponse;
AdminEventServiceAttachTicketBonusMediaResponse.runtime = protobuf_1.proto3;
AdminEventServiceAttachTicketBonusMediaResponse.typeName = "spwn.event.v1.AdminEventServiceAttachTicketBonusMediaResponse";
AdminEventServiceAttachTicketBonusMediaResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetTicketBonusMediaRequest
 */
class AdminEventServiceGetTicketBonusMediaRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: string ticket_id = 2;
         */
        this.ticketId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetTicketBonusMediaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetTicketBonusMediaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetTicketBonusMediaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetTicketBonusMediaRequest, a, b);
    }
}
exports.AdminEventServiceGetTicketBonusMediaRequest = AdminEventServiceGetTicketBonusMediaRequest;
AdminEventServiceGetTicketBonusMediaRequest.runtime = protobuf_1.proto3;
AdminEventServiceGetTicketBonusMediaRequest.typeName = "spwn.event.v1.AdminEventServiceGetTicketBonusMediaRequest";
AdminEventServiceGetTicketBonusMediaRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetTicketBonusMediaResponse
 */
class AdminEventServiceGetTicketBonusMediaResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.AdminEventServiceGetTicketBonusMediaResponse.TicketBonusMediaData ticket_bonus_media = 1;
         */
        this.ticketBonusMedia = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetTicketBonusMediaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetTicketBonusMediaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetTicketBonusMediaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetTicketBonusMediaResponse, a, b);
    }
}
exports.AdminEventServiceGetTicketBonusMediaResponse = AdminEventServiceGetTicketBonusMediaResponse;
AdminEventServiceGetTicketBonusMediaResponse.runtime = protobuf_1.proto3;
AdminEventServiceGetTicketBonusMediaResponse.typeName = "spwn.event.v1.AdminEventServiceGetTicketBonusMediaResponse";
AdminEventServiceGetTicketBonusMediaResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_bonus_media", kind: "message", T: AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetTicketBonusMediaResponse.TicketBonusMediaData
 */
class AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string url_for_download = 2;
         */
        this.urlForDownload = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData, a, b);
    }
}
exports.AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData = AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData;
AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData.runtime = protobuf_1.proto3;
AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData.typeName = "spwn.event.v1.AdminEventServiceGetTicketBonusMediaResponse.TicketBonusMediaData";
AdminEventServiceGetTicketBonusMediaResponse_TicketBonusMediaData.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bonus_info", kind: "message", T: admin_common_pb_1.TicketBonusMedia },
    { no: 2, name: "url_for_download", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceDetachTicketBonusMediaRequest
 */
class AdminEventServiceDetachTicketBonusMediaRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: string ticket_id = 2;
         */
        this.ticketId = "";
        /**
         * @generated from field: string media_id = 3;
         */
        this.mediaId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceDetachTicketBonusMediaRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceDetachTicketBonusMediaRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceDetachTicketBonusMediaRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceDetachTicketBonusMediaRequest, a, b);
    }
}
exports.AdminEventServiceDetachTicketBonusMediaRequest = AdminEventServiceDetachTicketBonusMediaRequest;
AdminEventServiceDetachTicketBonusMediaRequest.runtime = protobuf_1.proto3;
AdminEventServiceDetachTicketBonusMediaRequest.typeName = "spwn.event.v1.AdminEventServiceDetachTicketBonusMediaRequest";
AdminEventServiceDetachTicketBonusMediaRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceDetachTicketBonusMediaResponse
 */
class AdminEventServiceDetachTicketBonusMediaResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string media_id = 1;
         */
        this.mediaId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceDetachTicketBonusMediaResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceDetachTicketBonusMediaResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceDetachTicketBonusMediaResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceDetachTicketBonusMediaResponse, a, b);
    }
}
exports.AdminEventServiceDetachTicketBonusMediaResponse = AdminEventServiceDetachTicketBonusMediaResponse;
AdminEventServiceDetachTicketBonusMediaResponse.runtime = protobuf_1.proto3;
AdminEventServiceDetachTicketBonusMediaResponse.typeName = "spwn.event.v1.AdminEventServiceDetachTicketBonusMediaResponse";
AdminEventServiceDetachTicketBonusMediaResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceStartLotteryWinnerProcessRequest
 */
class AdminEventServiceStartLotteryWinnerProcessRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * 当選者のユーザID
         *
         * @generated from field: repeated string winner_user_ids = 2;
         */
        this.winnerUserIds = [];
        /**
         * メールの件名
         *
         * @generated from field: string mail_subject = 3;
         */
        this.mailSubject = "";
        /**
         * メールの本文
         *
         * @generated from field: string mail_body = 4;
         */
        this.mailBody = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceStartLotteryWinnerProcessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceStartLotteryWinnerProcessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceStartLotteryWinnerProcessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceStartLotteryWinnerProcessRequest, a, b);
    }
}
exports.AdminEventServiceStartLotteryWinnerProcessRequest = AdminEventServiceStartLotteryWinnerProcessRequest;
AdminEventServiceStartLotteryWinnerProcessRequest.runtime = protobuf_1.proto3;
AdminEventServiceStartLotteryWinnerProcessRequest.typeName = "spwn.event.v1.AdminEventServiceStartLotteryWinnerProcessRequest";
AdminEventServiceStartLotteryWinnerProcessRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "winner_user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "mail_subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mail_body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceStartLotteryWinnerProcessResponse
 */
class AdminEventServiceStartLotteryWinnerProcessResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceStartLotteryWinnerProcessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceStartLotteryWinnerProcessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceStartLotteryWinnerProcessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceStartLotteryWinnerProcessResponse, a, b);
    }
}
exports.AdminEventServiceStartLotteryWinnerProcessResponse = AdminEventServiceStartLotteryWinnerProcessResponse;
AdminEventServiceStartLotteryWinnerProcessResponse.runtime = protobuf_1.proto3;
AdminEventServiceStartLotteryWinnerProcessResponse.typeName = "spwn.event.v1.AdminEventServiceStartLotteryWinnerProcessResponse";
AdminEventServiceStartLotteryWinnerProcessResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.event.v1.AdminEventServiceStartLotteryLoserProcessRequest
 */
class AdminEventServiceStartLotteryLoserProcessRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * 落選者のユーザID
         *
         * @generated from field: repeated string loser_user_ids = 2;
         */
        this.loserUserIds = [];
        /**
         * メールの件名
         *
         * @generated from field: string mail_subject = 3;
         */
        this.mailSubject = "";
        /**
         * メールの本文
         *
         * @generated from field: string mail_body = 4;
         */
        this.mailBody = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceStartLotteryLoserProcessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceStartLotteryLoserProcessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceStartLotteryLoserProcessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceStartLotteryLoserProcessRequest, a, b);
    }
}
exports.AdminEventServiceStartLotteryLoserProcessRequest = AdminEventServiceStartLotteryLoserProcessRequest;
AdminEventServiceStartLotteryLoserProcessRequest.runtime = protobuf_1.proto3;
AdminEventServiceStartLotteryLoserProcessRequest.typeName = "spwn.event.v1.AdminEventServiceStartLotteryLoserProcessRequest";
AdminEventServiceStartLotteryLoserProcessRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "loser_user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "mail_subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mail_body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceStartLotteryLoserProcessResponse
 */
class AdminEventServiceStartLotteryLoserProcessResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceStartLotteryLoserProcessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceStartLotteryLoserProcessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceStartLotteryLoserProcessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceStartLotteryLoserProcessResponse, a, b);
    }
}
exports.AdminEventServiceStartLotteryLoserProcessResponse = AdminEventServiceStartLotteryLoserProcessResponse;
AdminEventServiceStartLotteryLoserProcessResponse.runtime = protobuf_1.proto3;
AdminEventServiceStartLotteryLoserProcessResponse.typeName = "spwn.event.v1.AdminEventServiceStartLotteryLoserProcessResponse";
AdminEventServiceStartLotteryLoserProcessResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.event.v1.AdminEventServiceExtractWinnerRequest
 */
class AdminEventServiceExtractWinnerRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.AdminEventServiceExtractWinnerRequest.WinnerTicket winner_tickets = 1;
         */
        this.winnerTickets = [];
        /**
         * 抽選候補抽出対象のチケットID
         *
         * @generated from field: repeated spwn.event.v1.AdminEventServiceExtractWinnerRequest.TargetUser target_users = 2;
         */
        this.targetUsers = [];
        /**
         * 過去当選履歴 firebase id
         *
         * @generated from field: repeated string history_winner_uids = 3;
         */
        this.historyWinnerUids = [];
        /**
         * @generated from field: string access_token = 4;
         */
        this.accessToken = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceExtractWinnerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceExtractWinnerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceExtractWinnerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceExtractWinnerRequest, a, b);
    }
}
exports.AdminEventServiceExtractWinnerRequest = AdminEventServiceExtractWinnerRequest;
AdminEventServiceExtractWinnerRequest.runtime = protobuf_1.proto3;
AdminEventServiceExtractWinnerRequest.typeName = "spwn.event.v1.AdminEventServiceExtractWinnerRequest";
AdminEventServiceExtractWinnerRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "winner_tickets", kind: "message", T: AdminEventServiceExtractWinnerRequest_WinnerTicket, repeated: true },
    { no: 2, name: "target_users", kind: "message", T: AdminEventServiceExtractWinnerRequest_TargetUser, repeated: true },
    { no: 3, name: "history_winner_uids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * 当選枚数
 *
 * @generated from message spwn.event.v1.AdminEventServiceExtractWinnerRequest.WinnerTicket
 */
class AdminEventServiceExtractWinnerRequest_WinnerTicket extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string ticket_id = 1;
         */
        this.ticketId = "";
        /**
         * コンビニ決済の当選枚数
         *
         * @generated from field: int32 cvs = 2;
         */
        this.cvs = 0;
        /**
         * クレジットカード決済の当選枚数
         *
         * @generated from field: int32 mem = 3;
         */
        this.mem = 0;
        /**
         * 同日チケットの分類ID
         *
         * @generated from field: string day_group = 4;
         */
        this.dayGroup = "";
        /**
         * チケットの優先順位（昇順）
         *
         * @generated from field: int32 order = 5;
         */
        this.order = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceExtractWinnerRequest_WinnerTicket().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceExtractWinnerRequest_WinnerTicket().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceExtractWinnerRequest_WinnerTicket().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceExtractWinnerRequest_WinnerTicket, a, b);
    }
}
exports.AdminEventServiceExtractWinnerRequest_WinnerTicket = AdminEventServiceExtractWinnerRequest_WinnerTicket;
AdminEventServiceExtractWinnerRequest_WinnerTicket.runtime = protobuf_1.proto3;
AdminEventServiceExtractWinnerRequest_WinnerTicket.typeName = "spwn.event.v1.AdminEventServiceExtractWinnerRequest.WinnerTicket";
AdminEventServiceExtractWinnerRequest_WinnerTicket.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cvs", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "mem", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "day_group", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * 抽選候補者
 *
 * @generated from message spwn.event.v1.AdminEventServiceExtractWinnerRequest.TargetUser
 */
class AdminEventServiceExtractWinnerRequest_TargetUser extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * firebase uid
         *
         * @generated from field: string uid = 1;
         */
        this.uid = "";
        /**
         * MEM or CVS
         *
         * @generated from field: string pay_type = 2;
         */
        this.payType = "";
        /**
         * 購入チケット枚数
         *
         * @generated from field: int32 ticket_count = 3;
         */
        this.ticketCount = 0;
        /**
         * 当選ステータス: 当選確定、当選候補、当選エラー、未処理、繰り越し待ち、落選
         *
         * @generated from field: string type = 4;
         */
        this.type = "";
        /**
         * チケットID
         *
         * @generated from field: string ticket_id = 5;
         */
        this.ticketId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceExtractWinnerRequest_TargetUser().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceExtractWinnerRequest_TargetUser().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceExtractWinnerRequest_TargetUser().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceExtractWinnerRequest_TargetUser, a, b);
    }
}
exports.AdminEventServiceExtractWinnerRequest_TargetUser = AdminEventServiceExtractWinnerRequest_TargetUser;
AdminEventServiceExtractWinnerRequest_TargetUser.runtime = protobuf_1.proto3;
AdminEventServiceExtractWinnerRequest_TargetUser.typeName = "spwn.event.v1.AdminEventServiceExtractWinnerRequest.TargetUser";
AdminEventServiceExtractWinnerRequest_TargetUser.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pay_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ticket_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceExtractWinnerResponse
 */
class AdminEventServiceExtractWinnerResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.AdminEventServiceExtractWinnerResponse.Applicant applicants = 1;
         */
        this.applicants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceExtractWinnerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceExtractWinnerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceExtractWinnerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceExtractWinnerResponse, a, b);
    }
}
exports.AdminEventServiceExtractWinnerResponse = AdminEventServiceExtractWinnerResponse;
AdminEventServiceExtractWinnerResponse.runtime = protobuf_1.proto3;
AdminEventServiceExtractWinnerResponse.typeName = "spwn.event.v1.AdminEventServiceExtractWinnerResponse";
AdminEventServiceExtractWinnerResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "applicants", kind: "message", T: AdminEventServiceExtractWinnerResponse_Applicant, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceExtractWinnerResponse.Applicant
 */
class AdminEventServiceExtractWinnerResponse_Applicant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * firebase uid
         *
         * @generated from field: string uid = 1;
         */
        this.uid = "";
        /**
         * MEM or CVS
         *
         * @generated from field: string pay_type = 2;
         */
        this.payType = "";
        /**
         * 購入チケット枚数
         *
         * @generated from field: int32 ticket_count = 3;
         */
        this.ticketCount = 0;
        /**
         * 当選ステータス: 当選確定、当選候補、当選エラー、未処理、繰り越し待ち、落選
         *
         * @generated from field: string type = 4;
         */
        this.type = "";
        /**
         * チケットID
         *
         * @generated from field: string ticket_id = 5;
         */
        this.ticketId = "";
        /**
         * 過去当選履歴があるか
         *
         * @generated from field: bool has_history_winner = 6;
         */
        this.hasHistoryWinner = false;
        /**
         * 同日当選履歴があるか
         *
         * @generated from field: bool has_history_winner_same_day = 7;
         */
        this.hasHistoryWinnerSameDay = false;
        /**
         * 同イベントの別日当選履歴があるか
         *
         * @generated from field: bool has_history_winner_same_event = 8;
         */
        this.hasHistoryWinnerSameEvent = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceExtractWinnerResponse_Applicant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceExtractWinnerResponse_Applicant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceExtractWinnerResponse_Applicant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceExtractWinnerResponse_Applicant, a, b);
    }
}
exports.AdminEventServiceExtractWinnerResponse_Applicant = AdminEventServiceExtractWinnerResponse_Applicant;
AdminEventServiceExtractWinnerResponse_Applicant.runtime = protobuf_1.proto3;
AdminEventServiceExtractWinnerResponse_Applicant.typeName = "spwn.event.v1.AdminEventServiceExtractWinnerResponse.Applicant";
AdminEventServiceExtractWinnerResponse_Applicant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pay_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ticket_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "has_history_winner", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "has_history_winner_same_day", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "has_history_winner_same_event", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceCreateVoucherCodeRequest
 */
class AdminEventServiceCreateVoucherCodeRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * プレフィックス
         *
         * @generated from field: string prefix = 1;
         */
        this.prefix = "";
        /**
         * イベントIDs
         *
         * @generated from field: repeated string event_ids = 2;
         */
        this.eventIds = [];
        /**
         * チケットIDs
         *
         * @generated from field: repeated string ticket_ids = 3;
         */
        this.ticketIds = [];
        /**
         * 最大使用回数
         *
         * @generated from field: int32 max_usable_count = 4;
         */
        this.maxUsableCount = 0;
        /**
         * 生成数
         *
         * @generated from field: int32 gen_num = 5;
         */
        this.genNum = 0;
        /**
         * 有効期限
         *
         * @generated from field: int64 expired_at = 6;
         */
        this.expiredAt = protobuf_1.protoInt64.zero;
        /**
         * どのイベントでも使えるフラグ？
         * 過去一度だけ使われているので用意はしておく
         *
         * @generated from field: bool any_events = 7;
         */
        this.anyEvents = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceCreateVoucherCodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceCreateVoucherCodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceCreateVoucherCodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceCreateVoucherCodeRequest, a, b);
    }
}
exports.AdminEventServiceCreateVoucherCodeRequest = AdminEventServiceCreateVoucherCodeRequest;
AdminEventServiceCreateVoucherCodeRequest.runtime = protobuf_1.proto3;
AdminEventServiceCreateVoucherCodeRequest.typeName = "spwn.event.v1.AdminEventServiceCreateVoucherCodeRequest";
AdminEventServiceCreateVoucherCodeRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "ticket_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "max_usable_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "gen_num", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "expired_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "any_events", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceCreateVoucherCodeResponse
 */
class AdminEventServiceCreateVoucherCodeResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * プレフィックス
         *
         * @generated from field: string prefix = 1;
         */
        this.prefix = "";
        /**
         * ファイル名
         *
         * @generated from field: string file_name = 2;
         */
        this.fileName = "";
        /**
         * 生成バウチャーコード
         *
         * @generated from field: repeated string org_codes = 3;
         */
        this.orgCodes = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceCreateVoucherCodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceCreateVoucherCodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceCreateVoucherCodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceCreateVoucherCodeResponse, a, b);
    }
}
exports.AdminEventServiceCreateVoucherCodeResponse = AdminEventServiceCreateVoucherCodeResponse;
AdminEventServiceCreateVoucherCodeResponse.runtime = protobuf_1.proto3;
AdminEventServiceCreateVoucherCodeResponse.typeName = "spwn.event.v1.AdminEventServiceCreateVoucherCodeResponse";
AdminEventServiceCreateVoucherCodeResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "org_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceAddEventRoleRequest
 */
class AdminEventServiceAddEventRoleRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceAddEventRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceAddEventRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceAddEventRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceAddEventRoleRequest, a, b);
    }
}
exports.AdminEventServiceAddEventRoleRequest = AdminEventServiceAddEventRoleRequest;
AdminEventServiceAddEventRoleRequest.runtime = protobuf_1.proto3;
AdminEventServiceAddEventRoleRequest.typeName = "spwn.event.v1.AdminEventServiceAddEventRoleRequest";
AdminEventServiceAddEventRoleRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_role", kind: "message", T: admin_common_pb_1.EventRole },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceAddEventRoleResponse
 */
class AdminEventServiceAddEventRoleResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceAddEventRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceAddEventRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceAddEventRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceAddEventRoleResponse, a, b);
    }
}
exports.AdminEventServiceAddEventRoleResponse = AdminEventServiceAddEventRoleResponse;
AdminEventServiceAddEventRoleResponse.runtime = protobuf_1.proto3;
AdminEventServiceAddEventRoleResponse.typeName = "spwn.event.v1.AdminEventServiceAddEventRoleResponse";
AdminEventServiceAddEventRoleResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.event.v1.AdminEventServiceRemoveEventRoleRequest
 */
class AdminEventServiceRemoveEventRoleRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceRemoveEventRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceRemoveEventRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceRemoveEventRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceRemoveEventRoleRequest, a, b);
    }
}
exports.AdminEventServiceRemoveEventRoleRequest = AdminEventServiceRemoveEventRoleRequest;
AdminEventServiceRemoveEventRoleRequest.runtime = protobuf_1.proto3;
AdminEventServiceRemoveEventRoleRequest.typeName = "spwn.event.v1.AdminEventServiceRemoveEventRoleRequest";
AdminEventServiceRemoveEventRoleRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_role", kind: "message", T: admin_common_pb_1.EventRole },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceRemoveEventRoleResponse
 */
class AdminEventServiceRemoveEventRoleResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceRemoveEventRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceRemoveEventRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceRemoveEventRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceRemoveEventRoleResponse, a, b);
    }
}
exports.AdminEventServiceRemoveEventRoleResponse = AdminEventServiceRemoveEventRoleResponse;
AdminEventServiceRemoveEventRoleResponse.runtime = protobuf_1.proto3;
AdminEventServiceRemoveEventRoleResponse.typeName = "spwn.event.v1.AdminEventServiceRemoveEventRoleResponse";
AdminEventServiceRemoveEventRoleResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetEventRolesRequest
 */
class AdminEventServiceGetEventRolesRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_firestore_id = 1;
         */
        this.eventFirestoreId = "";
        /**
         * @generated from field: repeated string role = 3;
         */
        this.role = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetEventRolesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetEventRolesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetEventRolesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetEventRolesRequest, a, b);
    }
}
exports.AdminEventServiceGetEventRolesRequest = AdminEventServiceGetEventRolesRequest;
AdminEventServiceGetEventRolesRequest.runtime = protobuf_1.proto3;
AdminEventServiceGetEventRolesRequest.typeName = "spwn.event.v1.AdminEventServiceGetEventRolesRequest";
AdminEventServiceGetEventRolesRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceGetEventRolesResponse
 */
class AdminEventServiceGetEventRolesResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.EventRoleWithUserName event_roles = 1;
         */
        this.eventRoles = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceGetEventRolesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceGetEventRolesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceGetEventRolesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceGetEventRolesResponse, a, b);
    }
}
exports.AdminEventServiceGetEventRolesResponse = AdminEventServiceGetEventRolesResponse;
AdminEventServiceGetEventRolesResponse.runtime = protobuf_1.proto3;
AdminEventServiceGetEventRolesResponse.typeName = "spwn.event.v1.AdminEventServiceGetEventRolesResponse";
AdminEventServiceGetEventRolesResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_roles", kind: "message", T: admin_common_pb_1.EventRoleWithUserName, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.AdminSeatInput
 */
class AdminSeatInput extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * @generated from field: int32 sort_order = 2;
         */
        this.sortOrder = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminSeatInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminSeatInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminSeatInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminSeatInput, a, b);
    }
}
exports.AdminSeatInput = AdminSeatInput;
AdminSeatInput.runtime = protobuf_1.proto3;
AdminSeatInput.typeName = "spwn.event.v1.AdminSeatInput";
AdminSeatInput.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.event.v1.AdminSeatSegmentInput
 */
class AdminSeatSegmentInput extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.event.v1.AdminSeatInput seats = 1;
         */
        this.seats = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminSeatSegmentInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminSeatSegmentInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminSeatSegmentInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminSeatSegmentInput, a, b);
    }
}
exports.AdminSeatSegmentInput = AdminSeatSegmentInput;
AdminSeatSegmentInput.runtime = protobuf_1.proto3;
AdminSeatSegmentInput.typeName = "spwn.event.v1.AdminSeatSegmentInput";
AdminSeatSegmentInput.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "seats", kind: "message", T: AdminSeatInput, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceImportSeatSegmentGroupRequest
 */
class AdminEventServiceImportSeatSegmentGroupRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: repeated string ticket_ids = 2;
         */
        this.ticketIds = [];
        /**
         * @generated from field: string seat_name_prefix = 3;
         */
        this.seatNamePrefix = "";
        /**
         * @generated from field: repeated spwn.event.v1.AdminSeatSegmentInput seat_segments = 4;
         */
        this.seatSegments = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceImportSeatSegmentGroupRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceImportSeatSegmentGroupRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceImportSeatSegmentGroupRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceImportSeatSegmentGroupRequest, a, b);
    }
}
exports.AdminEventServiceImportSeatSegmentGroupRequest = AdminEventServiceImportSeatSegmentGroupRequest;
AdminEventServiceImportSeatSegmentGroupRequest.runtime = protobuf_1.proto3;
AdminEventServiceImportSeatSegmentGroupRequest.typeName = "spwn.event.v1.AdminEventServiceImportSeatSegmentGroupRequest";
AdminEventServiceImportSeatSegmentGroupRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "seat_name_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "seat_segments", kind: "message", T: AdminSeatSegmentInput, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceImportSeatSegmentGroupResponse
 */
class AdminEventServiceImportSeatSegmentGroupResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string seat_segment_group_id = 1;
         */
        this.seatSegmentGroupId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceImportSeatSegmentGroupResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceImportSeatSegmentGroupResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceImportSeatSegmentGroupResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceImportSeatSegmentGroupResponse, a, b);
    }
}
exports.AdminEventServiceImportSeatSegmentGroupResponse = AdminEventServiceImportSeatSegmentGroupResponse;
AdminEventServiceImportSeatSegmentGroupResponse.runtime = protobuf_1.proto3;
AdminEventServiceImportSeatSegmentGroupResponse.typeName = "spwn.event.v1.AdminEventServiceImportSeatSegmentGroupResponse";
AdminEventServiceImportSeatSegmentGroupResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "seat_segment_group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceBulkAssignSeatsRequest
 */
class AdminEventServiceBulkAssignSeatsRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * @generated from field: string ticket_id = 2;
         */
        this.ticketId = "";
        /**
         * true の場合は永続化せず、割り当て予定表だけを返す（dry-run）
         *
         * @generated from field: bool dry_run = 3;
         */
        this.dryRun = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceBulkAssignSeatsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceBulkAssignSeatsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceBulkAssignSeatsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceBulkAssignSeatsRequest, a, b);
    }
}
exports.AdminEventServiceBulkAssignSeatsRequest = AdminEventServiceBulkAssignSeatsRequest;
AdminEventServiceBulkAssignSeatsRequest.runtime = protobuf_1.proto3;
AdminEventServiceBulkAssignSeatsRequest.typeName = "spwn.event.v1.AdminEventServiceBulkAssignSeatsRequest";
AdminEventServiceBulkAssignSeatsRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "dry_run", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.event.v1.AdminEventServiceBulkAssignSeatsResponse
 */
class AdminEventServiceBulkAssignSeatsResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 割り当て予定（dry-run）／割り当て結果（実行）の予定表。plan 順。
         *
         * @generated from field: repeated spwn.event.v1.BulkSeatAssignmentRow assignments = 1;
         */
        this.assignments = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminEventServiceBulkAssignSeatsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminEventServiceBulkAssignSeatsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminEventServiceBulkAssignSeatsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminEventServiceBulkAssignSeatsResponse, a, b);
    }
}
exports.AdminEventServiceBulkAssignSeatsResponse = AdminEventServiceBulkAssignSeatsResponse;
AdminEventServiceBulkAssignSeatsResponse.runtime = protobuf_1.proto3;
AdminEventServiceBulkAssignSeatsResponse.typeName = "spwn.event.v1.AdminEventServiceBulkAssignSeatsResponse";
AdminEventServiceBulkAssignSeatsResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "assignments", kind: "message", T: BulkSeatAssignmentRow, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.BulkSeatAssignmentRow
 */
class BulkSeatAssignmentRow extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * {uid}_{ticketId}_{idx}（issuedTicket の docId）
         *
         * @generated from field: string issued_ticket_doc_id = 1;
         */
        this.issuedTicketDocId = "";
        /**
         * @generated from field: string owner = 2;
         */
        this.owner = "";
        /**
         * 座席番号（seat.name 相当）
         *
         * @generated from field: string seat = 3;
         */
        this.seat = "";
        /**
         * @generated from field: string ticket_id = 4;
         */
        this.ticketId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BulkSeatAssignmentRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkSeatAssignmentRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkSeatAssignmentRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(BulkSeatAssignmentRow, a, b);
    }
}
exports.BulkSeatAssignmentRow = BulkSeatAssignmentRow;
BulkSeatAssignmentRow.runtime = protobuf_1.proto3;
BulkSeatAssignmentRow.typeName = "spwn.event.v1.BulkSeatAssignmentRow";
BulkSeatAssignmentRow.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "issued_ticket_doc_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "seat", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=admin_service_pb.js.map